export const ProfilePageStyles = {
  container: "container mx-auto sm:px-2 md:px-4 lg:px-6 py-6 relative ml-3 sm:ml-0",
  headerContainer: "flex flex-col sm:flex-row justify-between items-start mb-4 sm:mb-6 gap-4 sm:gap-0",
  headerLeftSection: "flex items-start",
  headerTitleContainer: "flex flex-col items-start",
  pageTitle: "text-2xl font-medium",
  profileSection: "flex flex-col items-center md:flex-row space-y-5 md:space-x-10 bg-white p-5 rounded-lg shadow-xl",
  profilePicture: "rounded-full sm:m-7 flex-shrink-0 min-w-[80px] min-h-[80px] md:min-w-[150px] md:min-h-[150px] object-cover",
  profilePictureSkeleton: "min-w-[80px] min-h-[80px] md:min-w-[150px] md:min-h-[150px] sm:m-7 flex-shrink-0",
  contentContainer: "flex flex-col items-center align-middle justify-center md:flex-row space-y-5 md:space-x-10 bg-white p-5 rounded-lg shadow-xl",
  horizontalDivider: "w-[90%] md:hidden border-t border-gray-200",
  infoContainer: "w-full flex flex-col space-y-4 flex-grow"
};